<template>
  <div>
    <BackLink
      :route-from="
        currentOrganisation && currentOrganisation.id ?
          {
            name: 'OrganisationDetail',
            params: {
              id: currentOrganisation.id
            }
          } :
          { name: 'JurisdictionsList' }
      "
      :route-name="
        currentOrganisation && currentOrganisation.id ?
          'OrganisationDetail' :
          'JurisdictionsList'
      "
      :title="
        currentOrganisation && currentOrganisation.display_name ?
          currentOrganisation.display_name :
          capitalizeFirstLetter($tc('words.jurisdiction', 2))
      "
    />
    <div class="container-xl">
      <div class="row">
        <div class="col-8">
          <JuridictionMap />
        </div>
        <div class="col-4">
          <JurisdictionNavigation v-if="$router.currentRoute.name === 'JurisdictionDetail'" />
          <JuridictionForm v-on="$listeners" />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <JuridictionFooter
            :mode="mode"
            v-on="$listeners"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import BackLink from '@/components/Elements/BackLink.vue';
import JuridictionForm from '@/app/jurisdiction/components/JuridictionForm.vue';
import JuridictionFooter from '@/app/jurisdiction/components/JuridictionFooter.vue';
import JuridictionMap from '@/app/jurisdiction/components/JuridictionMap.vue';
import JurisdictionNavigation from '@/app/jurisdiction/components/JurisdictionNavigation.vue';

export default {
  name: 'JurisdictionLayout',

  components: {
    BackLink,
    JuridictionForm,
    JuridictionFooter,
    JuridictionMap,
    JurisdictionNavigation
  },

  props: {
    routeFrom: {
      type: Object,
      default: () => {
        return null;
      }
    },
    mode: {
      type: String,
      default: 'create'
    }
  },

  computed: {
    ...mapState('organisations', [
      'currentOrganisation'
    ]),
  }
};
</script>